import type { LiffProfile } from "./use-liff.ts";

/**
 * Stand-in LINE avatar so the "photo pulled from LINE by default" path is
 * visible in mock mode (real LIFF returns a CDN `pictureUrl`). Inline SVG keeps
 * it offline and dependency-free.
 */
const mockLinePicture = `data:image/svg+xml,${encodeURIComponent(
  "<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 96 96'>" +
    "<defs><linearGradient id='g' x1='0' y1='0' x2='0' y2='1'>" +
    "<stop offset='0' stop-color='#4a3b28'/><stop offset='1' stop-color='#221b13'/>" +
    "</linearGradient></defs>" +
    "<rect width='96' height='96' fill='url(#g)'/>" +
    "<circle cx='48' cy='40' r='17' fill='#e6d6b8'/>" +
    "<path d='M18 90c3-18 15-27 30-27s27 9 30 27z' fill='#e6d6b8'/></svg>",
)}`;

/** Mock LINE profile used in local dev (VITE_LIFF_MOCK=1). */
export const mockProfile: LiffProfile = {
  userId: "Udevmock0000000000000000000000001",
  displayName: "เดฟ (Dev Tester)",
  pictureUrl: mockLinePicture,
  statusMessage: "เบาๆ นะคืนนี้",
};
